// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"4980c3432fdebca0d768","303":"085b140692595b772718","495":"5e4ced3deb2069b67d15"}[chunkId] + ".js";
};